<template>
    <kgr-form-scaffold
        :with-primary-buttons="false"
        @backBtnClicked="redirectToOverview"
    >
        <kgr-loader v-show="loading" />
        <template v-if="!loading">
            <div
                v-for="serviceRecipient in serviceRecipients"
                :key="serviceRecipient.id"
                class="kgr-postfix kgr-postfix--gutters kgr-postfix--center kgr-row kgr-row--smallMargin"
            >
                <div class="kgr-postfix__fluid profile">
                    <div class="kgr-postfix kgr-postfix--center kgr-postfix--smallGutters">
                        <div class="kgr-postfix__fixed">
                            <div class="kgr-text kgr-text--bold">
                                <a :href="memberUrl(serviceRecipient.id)">
                                    {{ `${serviceRecipient.firstName} ${serviceRecipient.lastName}` }}
                                </a>
                            </div>
                        </div>
                        <div class="kgr-postfix__fixed">
                            <button
                                class="kgr-button kgr-button--small"
                                @click="goToMember(serviceRecipient.id)"
                            >
                                {{ $t('Beiträge anzeigen') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </kgr-form-scaffold>
</template>

<script>
import FormScaffold from '../../../components/common/form/FormScaffold';
import Loading from '../../../components/common/Loading.vue';
import UrlMixin from '../../../components/members/UrlMixin.vue';
import axios from 'axios';

export default {
    components: {
        'kgr-loader': Loading,
        'kgr-form-scaffold': FormScaffold,
    },
    mixins: [UrlMixin],
    props: {
        id: {
            type: Number,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            loading: true,
            serviceRecipients: [],
        };
    },
    created() {
        this.load();
    },
    methods: {
        memberUrl(memberId) {
            return this.urlForMember(memberId);
        },
        load() {
            this.loading = true;
            axios
                .get(`/club/members/${this.id}/service-recipients`)
                .then((response) => {
                    this.serviceRecipients = response.data.data.map((serviceRecipient) => {
                        return {
                            id: serviceRecipient.id,
                            firstName: serviceRecipient.firstName,
                            lastName: serviceRecipient.lastName,
                        };
                    });
                    this.loading = false;
                });
        },
        goToMember(memberId) {
            window.location = `/backend/clubs/members/${memberId}/accounting/fee-assignment`;
        },
        redirectToOverview() {
            window.location = `/backend/clubs/${this.clubId}/members`;
        },
    },
};
</script>
